/*!
    jquery.megamenu.js
*/

(function ($) {
  jQuery.fn["hgsmegamenu"] = function (options?: megaMenuOptions) {
    const settings: megaMenuOptions = $.extend(
      {
        duration: 300,
        delay: 0,
        reveal: "hover",
        anchorSizeSelector: null,
      },
      options
    );

    const menus: menuObject[] = [];
    let $shim: JQuery | null = null;

    /** adds an iframe to the document */
    const createShim = function () {
      $shim = $(
        '<iframe id="outlineiframeshim" src="' +
          (location.protocol == "https:" ? "/blank.htm" : "about:blank") +
          '" style="display:none; left:0; top:0; z-index:999; position:absolute; filter:progid:DXImageTransform.Microsoft.Alpha(style=0,opacity=0)" frameBorder="0" scrolling="no"></iframe>'
      );
      $(document.body).append($shim);
    };

    /**
     * Sets up the menu object and adds it to the menu array
     * @param anchor
     * @param ul
     * @param dropMenu
     * @returns
     */
    const defineMenu = function (anchor, ul, dropMenu): menuObject {
      const menu = { anchor: anchor, ul: ul, menuContainer: dropMenu };
      menus.push(menu);
      return menu;
    };

    /**
     * gets the menu from the list given an index
     * @param ix
     * @returns
     */
    const getMenu = function (ix) {
      return menus[parseInt(ix, 10)];
    };

    /**
     * calculates the position that the menu container (drop down) should be
     * @param menu
     * @returns
     */
    const calculatePosition = function (menu: menuObject) {
      let $anchor = menu.anchor;

      if (settings.anchorSizeSelector) {
        $anchor = $anchor.find(settings.anchorSizeSelector);
      }

      const pos = {
        anchorwidth: 0,
        anchorheight: 0,
        offsetx: 0,
        offsety: 0,
      };

      pos.anchorwidth = $anchor.outerWidth();
      if (isNaN(pos.anchorwidth)) {
        pos.anchorwidth = 0;
      }

      pos.anchorheight = $anchor.outerHeight();
      if (isNaN(pos.anchorheight)) {
        pos.anchorheight = 50;
      }

      const offset = $anchor.offset();
      if (offset) {
        pos.offsetx = offset.left;
        pos.offsety = offset.top;
      }

      return pos;
    };

    const alignMenu = function (menu: menuObject) {
      const pos = calculatePosition(menu);

      const $menu = menu.menuContainer;

      const menuleft = pos.offsetx;

      const menutop = pos.offsety + pos.anchorheight; //get y coord of menu

      $menu.css({ left: menuleft + "px", top: menutop + "px" });

      if ($shim) {
        $shim.css({
          width: menu.actualwidth + "px",
          height: menu.actualheight + "px",
          left: menuleft + "px",
          top: menutop + "px",
          display: "block",
        });
      }
    };

    const hideMenu = function (menu: menuObject) {
      const $menu = menu.menuContainer,
        $ul = menu.ul;

      $ul.css("visibility", "hidden");
      if ($shim) {
        $shim.css({ display: "none", left: 0, top: 0 });
      }
      $menu.slideUp(settings.duration, function () {
        menu.anchor.parent().removeClass("active");
      });
    };

    const showMenu = function (e: JQueryMouseEventObject, menu: menuObject) {
      const $menu = menu.menuContainer,
        $ul = menu.ul;

      menu.anchor.parent().addClass("active");

      if ($menu.css("display") == "none") {
        alignMenu(menu);

        $menu.slideDown("fast", function () {
          $ul.css("visibility", "visible");
        });
      } else if ($menu.css("display") == "block" && e.type == "click") {
        //if menu is hidden and this is a "click" event (versus "mouseout")
        hideMenu(menu);
      }
      return false;
    };

    const getMenuForElement = (e: JQueryMouseEventObject) => {
      const an = e.currentTarget as HTMLElement;
      return getMenu(an.dataset["_menupos"]);
    };

    const setupMenu = (menu: menuObject) => {
      // store existing sizes of menu
      menu.actualwidth = menu.menuContainer.outerWidth();
      if (isNaN(menu.actualwidth)) {
        menu.actualwidth = 0;
      } // fixes a bug from earlier versions of jQuery UI

      menu.actualheight = menu.menuContainer.outerHeight();
      if (isNaN(menu.actualheight)) {
        menu.actualheight = 200;
      }

      $(document.body).append(menu.menuContainer);

      (this as any).zIndexVal = (this as any).zIndexVal || 1000;

      menu.menuContainer.css("z-index", ++(this as any).zIndexVal).hide();

      menu.ul.css("visibility", "hidden");

      /* Apply Event Handlers to Anchor Element */
      menu.anchor.bind(
        settings.reveal == "click" ? "click" : "mouseenter",
        function (e) {
          const menuinfo = getMenuForElement(e);

          clearTimeout(menuinfo.hidetimer); //cancel hide menu timer
          if (window.innerWidth > 1000) {
            return showMenu(e, menuinfo);
          }
        }
      );

      menu.anchor.bind("mouseleave", function (e) {
        const menuinfo = getMenuForElement(e);
        if (
          e.relatedTarget != menuinfo.menuContainer.get(0) &&
          jQuery(e.relatedTarget).parents(
            "#" + menuinfo.menuContainer.attr("id")
          ).length == 0
        ) {
          //check that mouse hasn't moved into menu object
          menuinfo.hidetimer = setTimeout(() => {
            hideMenu(menuinfo);
          }, settings.delay);
        }
      });

      /* Apply Event Handlers to Menu Container Element */
      menu.menuContainer.bind("mouseenter", function (e) {
        const menuinfo = getMenuForElement(e);
        clearTimeout(menuinfo.hidetimer); //cancel hide menu timer
      });

      menu.menuContainer.bind("click mouseleave", function (e) {
        const menuinfo = getMenuForElement(e);
        menuinfo.hidetimer = setTimeout(function () {
          //add delay before hiding menu
          hideMenu(menuinfo);
        }, settings.delay);
      });
    };

    const parents = $(this.children("li").has("ul"));
    $.each(parents, function (ix, val) {
      const anchor = $(val),
        ul = $(val).children("ul"),
        menuContainer = $(
          '<div class="megamenu" id="_menucon' + ix + '"></div>'
        );

      menuContainer.append(ul);

      const menu = defineMenu(anchor, ul, menuContainer);
      (menu.anchor[0] as HTMLElement).dataset["_menupos"] = ix;
      (menu.menuContainer[0] as HTMLElement).dataset["_menupos"] = ix;

      setupMenu(menu);
    });

    createShim();
  };
})(jQuery);

export {};
